import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import ReactDragList from 'react-drag-list';
import { toast, ToastContainer} from 'react-toastify';
import {Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane} from 'reactstrap';

import withServices  from '../../../../HOCs/withServices';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import CustomNav from '../../../../components/CustomNav/CustomNav.Component';
import Card from '../../../../components/Card';

import CustomDonutChart from '../../../../common/DataViz/customDonutChart.Component';
// import CustomRadialChart from '../../../../common/customRadialChart.Component';
import StackedBarGraph from '../../../../common/DataViz/Admin/stackedBarGraph.Component';

import { ModalWrapper, WidgetWrapper, Wrapper, Content, ContentCol, ContentRow, ContentRowSingleCol, StyledSectionHeader} from './HomePage.styles';
import 'react-drag-list/assets/index.css';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
  }
  
  interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
  }

class HomePage extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoToState = this.onGoToState.bind(this);
        this.onMessages = this.onMessages.bind(this);
        this.onReports = this.onReports.bind(this);
        this.onVerify = this.onVerify.bind(this);
    }



    public setTab(param, e) {
        const data = this.state.data
        data.activetab = param;
        this.setState({
            data
         });
    }

    public dragComplete(e) {
        console.log(e);
    }


    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async onVerify() {

        const res = await this.props.services.adminAPI.verifyAllInstitutionScores()
        
        if (res.ok) {
            toast.success("Success");
        }
        else{
            toast.error("Failed to complete request");
        }
    }

    public onMessages() {
        const dest = this.props.services.currentBaseUrl + 'messages';
        this.props.history.push(dest);       
    }

    public onReports() {
        const dest = this.props.services.currentBaseUrl + 'reports';
        this.props.history.push(dest); 
    }

    public onGoToState(state) {
        // const dest = this.props.services.currentBaseUrl + state;
        
        // this.setState({
        //     isNavigate: true,
        //     destination: dest
        // })
        const { services: { currentBaseUrl }, history } = this.props;
        history.push(`${currentBaseUrl}${state}`);
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const [sessionRes, usersRes, assessmentRes, lessonsRes, coursesRes, setsRes, collectionsRes, iconsRes, badgesRes, templatesRes, systemRes] = await Promise.all([adminAPI.getSessionInfo(),
             adminAPI.getUserSummary(),
             adminAPI.getAssessmentSummary(),
             adminAPI.getItemCountGeneral('lessons'),
             adminAPI.getItemCountGeneral('courses'),
             adminAPI.getItemCountGeneral('interaction_sets'),
             adminAPI.getItemCountGeneral('asset_collections'),
             adminAPI.getItemCountGeneral('icons'),
             adminAPI.getItemCountGeneral('badge_allocations'),
             adminAPI.getItemCountGeneral('data_templates'),
             adminAPI.getItemCountGeneral('system_variables')
            ])

        

        if (sessionRes.ok) {

            const sessionItems = sessionRes.data.sessions;

            const userItems = usersRes.data.users;

            const assessmentItems = assessmentRes.data.assessments;

            const lessonTotal = lessonsRes.data.total;

            const coursesTotal = coursesRes.data.total;

            const setsTotal = setsRes.data.total;

            const collectionsTotal = collectionsRes.data.total;

            const iconsTotal = iconsRes.data.total;

            const badgesTotal = badgesRes.data.total;

            const templatesTotal = templatesRes.data.total;

            const systemTotal = systemRes.data.total;

            this.setState(
                {
                     data: {
                        activetab: '1',
                        assessmentItems,
                        badgesTotal,
                        collectionsTotal,
                        coursesTotal,
                        iconsTotal,
                        lessonTotal,
                        sessionInfo: sessionItems,
                        setsTotal,
                        systemTotal,
                        templatesTotal,
                        userItems,
                     }
                }
            )

        }
        
    }

    public assessmentSessions(data){
        if (data.sessionInfo) {
            return(
                <div className="admin-home-graph">
                  <h2 className="admin-home-title">Assessment Sessions Last 30 days</h2>
                  {/* <CustomGraph /> */}
                  <StackedBarGraph keys={['total']} leftlegend={"number"} bottomlegend={"date"} data={data.sessionInfo} index={"day"}/>
                </div>
              )
        }
        else{
            return (<p>No data to display</p>)
        }
        
      }

    

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              
              <CustomNav {...this.props} logoutParent={this.onLogout} onMessages={this.onMessages} onReports={this.onReports}/>
              
              <Content>
            
                <Row>
                    <div className="admin-center-profile">
                        <h2 className="admin-profile-title">Summary</h2>
                        <div className="admin-profile-holder">
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.userItems.learners} />
                                <h4 className="detail-name">Profiles</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('userprofiles')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.userItems.learners} />
                                <h4 className="detail-name">Subscriptions</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('subscriptions')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.userItems.institutions} />
                                <h4 className="detail-name">Institutions</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('institutions')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.userItems.teachers} />
                                <h4 className="detail-name">Teachers</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('teachers')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.userItems.parents} />
                                <h4 className="detail-name">Parents</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('parents')} className="blue-button learnmore">View More</button>
                            </div>
                        </div>
                    </div>
                </Row>

                <Row>

                    {this.assessmentSessions(data)}
                </Row>

                <Row>
                    <div className="admin-center-profile">
                        <h2 className="admin-profile-title">Assessments</h2>
                        <div className="admin-profile-holder">
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.assessmentItems.assessments} />
                                <h4 className="detail-name">Assessments</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('assessments')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.assessmentItems.completed} />
                                <h4 className="detail-name">Completed Preassessments</h4>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.assessmentItems.incomplete} />
                                <h4 className="detail-name">Incomplete Preassessments</h4>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {12} />
                                <h4 className="detail-name">Configuration</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('assessmentconfig')} className="blue-button learnmore">View More</button>
                            </div>
                        </div>
                    </div>
                </Row>

                <Row>
                    <div className="admin-center-profile">
                        <h2 className="admin-profile-title">Content</h2>
                        <div className="admin-profile-holder">
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.lessonTotal} />
                                <h4 className="detail-name">Lessons</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('lessons')} className="blue-button learnmore">View More</button>
                            </div>

                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.lessonTotal} />
                                <h4 className="detail-name">AutoRecommender</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('autorecommender_configs')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.coursesTotal} />
                                <h4 className="detail-name">Courses</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('courses')} className="blue-button learnmore">View More</button>
                                
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.setsTotal} />
                                <h4 className="detail-name">Interaction Sets</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('interaction_sets')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {12} />
                                <h4 className="detail-name">Asset Collections</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('asset_collections')} className="blue-button learnmore">View More</button>
                            </div>
                        </div>
                    </div>
                </Row>

                <Row>
                    <div className="admin-center-profile">
                        <h2 className="admin-profile-title">System</h2>
                        <div className="admin-profile-holder">
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.iconsTotal} />
                                <h4 className="detail-name">Icons</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('icons')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#18ee97" text = {data.badgesTotal} />
                                <h4 className="detail-name">Badges awarded</h4>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.templatesTotal} />
                                <h4 className="detail-name">Templates</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('templates')} className="blue-button learnmore">View More</button>
                            </div>
                            <div className="admin-summary-values">
                                <CustomDonutChart value = {100} color = "#e7233d" text = {data.systemTotal} />
                                <h4 className="detail-name">System Variables</h4>
                                {/*tslint:disable-next-line jsx-no-lambda*/}
                                <button onClick={() => this.onGoToState('system_variables')} className="blue-button learnmore">View More</button>
                            </div>
                        </div>
                    </div>
                </Row>
                  

              </Content>
            </Wrapper>  
        )
    }
}

export default withServices(HomePage);


// WEBPACK FOOTER //
// ./src/pages/Admin/Home/HomePage/HomePage.tsx